import httpService from './HttpService';

export default class AddressService {
  static baseUrl() {
    return '/servicocep-api/logradouro';
  }

  static list(params = {}) {
    return httpService.get(
      `${this.baseUrl()}/consulta`,
      {
        params,
      },
    );
  }

  static get(id) {
    return httpService.get(
      `${this.baseUrl()}/${id}`,
    );
  }

  static add(payload) {
    return httpService.post(
      `${this.baseUrl()}/inserir`,
      payload,
    );
  }
}
